import { createQueryKey } from '../../../query/createQueryKeyFactory';
import { QueryKey } from '../../../query/types';

const quickbooksKeys = <T extends QueryKey>(keys: T) =>
  createQueryKey({
    all: [...keys, 'quickbooks'] as const,
    callback: [...keys, 'quickbooks', 'callback'] as const,
    status: [...keys, 'quickbooks', 'status'] as const,
  });

export { quickbooksKeys };
